export enum DOSSIER_FACILE_STATUS {
  validated = 'VALIDATED',
  toProcess = 'TO_PROCESS',
  incomplete = 'INCOMPLETE',
}

export interface ApplicationDossierFacile {
  full_pdf_url: string
  file_url: string
  id: string
  last_update: string
  lead_id: string
  status: DOSSIER_FACILE_STATUS
}
